import "./button.css"
import { useNavigate } from "react-router-dom";

export default function Button({ text, navigateTo, onClick, type, disabled, buttonStyle, ...attributes }) {
    const navigate = useNavigate();

    return (
        <button
            type={type ? type : "button"}
            onClick={navigateTo ? () => navigate(navigateTo) : onClick}
            className={`custom-button ${buttonStyle}`}
            disabled={disabled}>
            {text}
        </button>
    );
}